import Shepherd from 'shepherd.js';

if($('.university.editor').length && !$('.onboarding-university-editor').length){
    
    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'university-editor'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: 'The University Editor',
        text: "Welcome to the University Editor. This will show you how your University Portal looks whilst you live edit it. If you want to remove innovations from your University Portal, please view your University innovation page via your dashboard.",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Toggle between views',
        text: "Using these two toggles, you can switch the view mode between a full view of your University Portal and the editor form.",
        attachTo: {
            element: '#editor-header .middle',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: 'Checking your progress',
        text: "This shows the percentage of your University Portal progress completion. You won't be able to save your University unless it is 100% complete.",
        attachTo: {
            element: '.radial-progress',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    });
    
    tour.addStep({
        title: 'Editing your University',
        text: "Complete the fields in this section to provide a brief overview of your University, as well as change the Portal colour, University logo and header image.",
        attachTo: {
            element: '.editor-section',
            on: $(window).width() < 992 ? 'top' : 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    });
    
    tour.addStep({
        title: 'Saving',
        text: "Once you've finished editing your University Portal, click the 'Save' button.",
        attachTo: {
            element: '#editor-header .right',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-5'
    });
    
    tour.addStep({
        title: "Once you're finished",
        text: "When you are finished in the editor you can click this button to go back to your dashboard or the previous page. Make sure you've saved your University Portal first though!",
        attachTo: {
            element: '#editor-header .left',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-6'
    });

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if($('.university.editor').length){
        tour.start();
    }
}
